import { render, staticRenderFns } from "./shoucang_mobile.vue?vue&type=template&id=f822db6a&scoped=true&"
import script from "./shoucang_mobile.vue?vue&type=script&lang=js&"
export * from "./shoucang_mobile.vue?vue&type=script&lang=js&"
import style0 from "./shoucang_mobile.vue?vue&type=style&index=0&id=f822db6a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f822db6a",
  null
  
)

export default component.exports